import(/* webpackMode: "eager" */ "C:\\Users\\nimad\\Desktop\\hero\\hero-general-next\\app\\globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\nimad\\Desktop\\hero\\hero-general-next\\app\\providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthRedirectHandler"] */ "C:\\Users\\nimad\\Desktop\\hero\\hero-general-next\\components\\AuthRedirectHandler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IframeProvider"] */ "C:\\Users\\nimad\\Desktop\\hero\\hero-general-next\\components\\ui\\AiChat\\IframeContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\nimad\\Desktop\\hero\\hero-general-next\\components\\ui\\Popup\\Popup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SetIP"] */ "C:\\Users\\nimad\\Desktop\\hero\\hero-general-next\\lib\\SetIP\\SetIP.tsx");
;
import(/* webpackMode: "eager" */ "C:\\Users\\nimad\\Desktop\\hero\\hero-general-next\\node_modules\\next\\dist\\client\\script.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "C:\\Users\\nimad\\Desktop\\hero\\hero-general-next\\node_modules\\nextjs-toploader\\dist\\index.js");
